var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-container" }, [
    _c(
      "div",
      { staticClass: "title" },
      [
        _c("h3", { staticStyle: { margin: "1rem", "font-size": "1.4rem" } }, [
          _vm._v("便利店销售额总报")
        ]),
        _c("el-date-picker", {
          staticStyle: { width: "20rem !important" },
          attrs: {
            editable: false,
            type: "daterange",
            "range-separator": "~",
            "start-placeholder": "开始日期",
            "end-placeholder": "结束日期",
            "value-format": "timestamp",
            "picker-options": _vm.pickerOptionsStart
          },
          model: {
            value: _vm.datePickerValue,
            callback: function($$v) {
              _vm.datePickerValue = $$v
            },
            expression: "datePickerValue"
          }
        }),
        _c("slot-counter-total-second", {
          attrs: {
            start: _vm.datePickerValue[0],
            end: _vm.datePickerValue[1],
            "total-counter-name": "ShopGMVTimeDistributionSlotCounter",
            "total-counter-display-name": "ShopGMVTimeDistributionSlotCounter",
            "total-counter-kind": "CST",
            "ref-index": _vm.refIndex,
            "slot-counter-name": "ShopGMVOCOSOTPCCounter"
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }